<template>
    <div class="inline-flex items-center gap-3">
        <div class="">
            <svg
                width="250"
                height="103"
                viewBox="0 0 585 103"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M561.132 50.6903L561.263 50.751H584.496C587.996 29.2263 572.874 11.2049 551.247 11.2049C531.997 11.2049 517.373 25.723 517.373 44.7438C517.373 63.7645 532.248 78.2826 551.872 78.2826C565.871 78.2826 576.621 71.1481 582.243 61.0117L568.371 54.7558C565.242 60.3859 559.373 63.7645 552.37 63.7645C543.496 63.7645 536.998 58.3835 534.748 50.751H561.129V50.6903H561.132ZM538.644 32.0929C538.644 24.4462 544.837 18.2505 552.468 18.2505C554.551 18.2505 556.528 18.7129 558.298 19.5416C556.252 20.6335 554.86 22.7888 554.86 25.2713C554.86 28.8564 557.763 31.7621 561.343 31.7621C563.218 31.7621 564.904 30.9619 566.086 29.685C566.224 30.4675 566.3 31.2713 566.3 32.0929C566.3 39.7396 560.107 45.9352 552.472 45.9352C544.84 45.9352 538.648 39.7361 538.648 32.0929H538.644Z"
                    fill="#1F2938"
                />
                <path
                    d="M451.537 50.751H401.792C404.042 58.3835 410.54 63.7645 419.415 63.7645C426.414 63.7645 432.287 60.3859 435.412 54.7558L449.288 61.0117C443.665 71.1481 432.916 78.2826 418.917 78.2826C399.295 78.2826 384.418 63.7645 384.418 44.7438C384.418 25.723 399.039 11.2049 418.288 11.2049C439.911 11.2049 455.037 29.2263 451.537 50.751ZM402.041 37.8617H434.664C432.414 30.6027 426.291 25.723 418.292 25.723C410.293 25.723 404.417 30.6027 402.045 37.8617H402.041Z"
                    fill="#1F2938"
                />
                <path
                    d="M484.393 72.528L467.894 12.4568H449.647L468.774 74.9963C469.141 76.2057 470.256 77.0307 471.521 77.0307H483.02L475.399 102.059H492.523L519.641 12.4568H502.517L484.393 72.528Z"
                    fill="#1F2938"
                />
                <path
                    d="M340.54 89.602H357.664L384.782 0H367.658C352.559 50.0472 350.022 58.4606 340.54 89.602Z"
                    fill="#FF421E"
                />
                <path
                    d="M325.55 53.8524C322.836 59.3153 317.085 63.7504 309.583 63.7504C299.349 63.7504 291.53 55.4598 291.53 44.7438C291.53 34.0277 299.345 25.7372 309.583 25.7372C317.121 25.7372 322.89 30.2079 325.585 35.7064L339.88 29.2618C335.262 19.9755 324.57 11.2049 309.583 11.2049C290.135 11.2049 275.155 25.8297 275.155 44.7438C275.155 63.6581 290.135 78.2826 309.583 78.2826C324.53 78.2826 335.209 69.5585 339.844 60.2968L325.55 53.8488V53.8524Z"
                    fill="#1F2938"
                />
                <path
                    d="M141.105 77.3508H126.217V36.2648L109.934 77.3508H97.8387L81.5555 36.2648V77.3508H66.6678V12.1367H87.324L104.353 54.713L121.379 12.1367H141.105V77.3508Z"
                    fill="#1F2938"
                />
                <path
                    d="M197.017 77.3508L192.086 64.4936H165.846L160.915 77.3508H145.005L170.591 12.1367H188.271L213.858 77.3508H197.017ZM171.149 50.5199H186.783L178.968 29.9304L171.153 50.5199H171.149Z"
                    fill="#1F2938"
                />
                <path
                    d="M272.654 77.3508H253.859L239.714 55.4562H233.573V77.3508H217.755V12.1367H246.598C261.393 12.1367 270.792 21.4515 270.792 33.8428C270.792 43.0651 265.766 50.3313 257.301 53.5926L272.654 77.3508ZM233.573 26.1107V41.4824H246.598C251.344 41.4824 254.413 38.2209 254.413 33.8428C254.413 29.4645 251.344 26.1107 246.598 26.1107H233.573Z"
                    fill="#1F2938"
                />
                <path
                    d="M27.0786 12.1367H0V77.3508H27.0786C46.431 77.3508 60.4836 63.1885 60.4836 44.7438C60.4836 26.2992 46.431 12.1367 27.0786 12.1367ZM25.6825 63.3768H15.818V26.1107H25.6825C36.7547 26.1107 44.1077 33.8427 44.1077 44.7438C44.1077 55.6448 36.7584 63.3768 25.6825 63.3768Z"
                    fill="#1F2938"
                />
            </svg>
        </div>
    </div>
</template>
<script setup lang="ts"></script>
